import { getInspections, getTenancy } from "actions";
import ActivityTab from "components/Activities/ActivityDynamic";
import { Collection as Facilities } from "components/Facilities";
// import { Collection as Inspections } from "components/Inspections";
import { Collection as Leases } from "components/Leases";
import { Card as Permissions } from "components/Permissions";
import { Aside, Breadcrumbs, Date, DefinitionItem, DefinitionList, Header, View, Workspace } from "components/Shared";
import { translate } from "lib";
import _ from "lodash";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";

interface Props extends RouteComponentProps {
	match: any;
}

const Tenancy = ({ match, history }: Props) => {
	const dispatch = useDispatch();
	const { id } = match.params;
	useEffect(() => {
		dispatch(getInspections());
		dispatch(getTenancy(id));
	}, [dispatch, id]);
	// const inspections = useSelector((store: tcpinpoint.Store) =>
	// 	_.filter(store.inspections, { inspectable_id: id })
	// ) as tcpinpoint.Inspection[];
	const queryStringParameters = useCallback(() => ({ tenancy_id: id }), [id]);
	const tenancy = useSelector((store: tcpinpoint.Store) => _.find(store.tenancies, { id })) as tcpinpoint.Tenancy;
	const property = useSelector((store: tcpinpoint.Store) =>
		_.find(store.properties, { id: _.get(tenancy, "property_id") })
	) as tcpinpoint.Property;

	// Need to send request to api server to get tenancy and proeperty from the url then render the list of project to link to on this page
	if (!!tenancy && !!property) {
		return (
			<React.Fragment>
				<Breadcrumbs
					items={[
						{ link: "/properties", title: translate("properties") },
						{ link: `/properties/${property.id}`, title: property.name },
						{ link: `/properties/${property.id}#buildings`, title: translate("tenancies") },
						{ title: tenancy.name }
					]}
				/>
				<Header
					resource={tenancy}
					stamp="tenancy"
					title={tenancy.name}
					subtitle={property.name}
					toolbar={[{ label: "edit", onClick: () => history.push(`/tenancies/${tenancy.id}/edit`) }]}
				/>
				<Workspace
					id={tenancy.id}
					className="tenancies"
					tabs={[
						<Facilities name="facilities" key="facilities" canAdd={false} resource={tenancy} />,
						// <Inspections name="inspections" key="inspections" inspections={inspections} resource={tenancy} />,
						<Leases name="leases" key="leases" tenancy={tenancy} />,
						<View name="dashboard">
							<DefinitionList>
								{/* Every Yardi unit field, in payload order (see how-does-api-works.md
								    — /unit_data and Units[] on /lease_data). DefinitionItem renders
								    nothing for a blank value, so units Yardi hasn't populated stay
								    clean and only the fields that carry data appear. */}
								<DefinitionItem title="unit_code" value={tenancy.unit_code} />
								{/* `unit_type` rather than the shared `kind` label key. */}
								<DefinitionItem title="unit_type" value={translate(tenancy.kind)} />
								<DefinitionItem title="location" value={tenancy.location} />
								<DefinitionItem title="size" value={tenancy.area} suffix="m²" />
								<DefinitionItem title="lease_area_sqm" value={tenancy.lease_area_sqm} suffix="m²" />
								<DefinitionItem title="actual_area_sqm" value={tenancy.actual_area_sqm} suffix="m²" />
								<DefinitionItem title="actual_area_sqft" value={tenancy.actual_area_sqft} suffix="ft²" />
								<DefinitionItem title="lease_area_sqft" value={tenancy.lease_area_sqft} suffix="ft²" />
								<DefinitionItem title="area_id" value={tenancy.area_id} />
								<DefinitionItem title="country" value={tenancy.country} />
								<DefinitionItem title="address" value={tenancy.address} />
								{/* Only shown when true — `exclude: false` is the normal state and
								    would otherwise add a row to every unit. */}
								<DefinitionItem title="exclude" value={tenancy.exclude ? translate("yes") : false} />
								<DefinitionItem title="zone" value={tenancy.zone} />
								<DefinitionItem title="sub_zone" value={tenancy.sub_zone} />
								<DefinitionItem title="portfolio" value={tenancy.portfolio} />
								<DefinitionItem
									title="as_of_date"
									value={tenancy.as_of_date ? <Date date={tenancy.as_of_date} showTime={false} /> : false}
								/>
								{/* unit_status is lease-level and lives on Lease — shown on the
								    lease screens, not here. */}
								<DefinitionItem title="removed_flag" value={tenancy.removed_flag} />
								<DefinitionItem title="relocation_status" value={tenancy.relocation_status} />
								{/* Yardi's own occupancy status for the unit, off /unit_data. NOT
								    `occupancy_status` above, which is TCP's folded answer — the two
								    disagree freely, which is why the label names Yardi. */}
								<DefinitionItem title="unit_occ_status" value={tenancy.unit_occ_status} />
								<DefinitionItem title="precinct" value={tenancy.precinct} />
								<DefinitionItem title="division" value={tenancy.division} />
							</DefinitionList>
						</View>
					]}
				/>
				<Aside>
					<ActivityTab queryStringParameters={queryStringParameters()} />
					<Permissions resource={tenancy} />
				</Aside>
			</React.Fragment>
		);
	}
	return null;
};

export default Tenancy;
